import { type QueryClient } from "@tanstack/react-query";

import { ROSTER_WINDOW_SETTINGS_URL_SUFFIX } from "./rosterWindowSettingsUrl";

// Matches on URL suffix so the predicate works whether `useGetParsedQuery`
// stores the query key as an absolute or relative URL.
export async function invalidateRosterWindowSettingsQueries(
  queryClient: QueryClient
): Promise<void> {
  await queryClient.invalidateQueries({
    predicate: (query) => {
      const firstKey = query.queryKey[0];
      return typeof firstKey === "string" && firstKey.endsWith(ROSTER_WINDOW_SETTINGS_URL_SUFFIX);
    },
  });
}
